import React, { useState } from "react";
import "./checkBoxDownHL.css";

const CheckBoxDownHLPure = (props) => {
    const {
        labelCheckBox, //Label to check
        valueCheckBox, //Value to check
        idCheckBox, //Id checkBox, string, number, you can use value labelCheckBox
        onChangeHandler, //Funtion to check
        checkedState, //State that change check
    } = props;

    const [valueCheck, setValueCheck] = useState(valueCheckBox || false);
    const handleChange = (event) => {
        setValueCheck(event.target.checked);
    };

    return (
        <div
            item
            xs={12}
            lg={12}
            md={12}
            sm={12}
            className="CheckBoxDownHLPure-container"
        >
            <label
                className="CheckBoxDownHLPure-label"
                htmlFor={idCheckBox}
                onClick={(e) => e.stopPropagation()}
            >
                <input
                    type="checkbox"
                    className="CheckBoxDownHLPure-input"
                    {...props}
                    id={idCheckBox}
                    name={labelCheckBox}
                    value={valueCheck}
                    checked={checkedState}
                    onClick={onChangeHandler ? onChangeHandler : handleChange}
                />
                <div className="CheckBoxDownHLPure-label-text">{labelCheckBox}</div>
            </label>

        </div>
    );
};

export { CheckBoxDownHLPure as default };
